export default __webpack_public_path__ + "static/media/front_detail.311f6256.png";